/*
 * @Author: caiqin.xie
 * @since: 2023-06-21 17:48:53
 * @lastTime: 2023-11-10 10:49:34
 * @LastEditors: caiqin.xie
 * @message: 
 */
import React, {useState} from "react";
import styles from "./index.module.scss";
import Rate from "../Rate"
import request from '@/common/request';
import { DOMAIN_API, CONTENTTYPEID} from '@/common/const'
import classNames from "classnames";
interface Iquestion {
  id?: string;
  title?: string; // 标题
  detail?: string; // 内容
  cover?: string; // 封面图
  ctry: string;
  words: Record<string, string>;
  isLike?: boolean; // 是否喜欢
  isDislike?: boolean; // 是否不喜欢
}


const QuestionItem = (props: Iquestion) => {
  const {id, title, detail, cover, ctry, words} = props
  const [showContent, setShowContent] = useState(false); // 是否展开内容
  const [isLike, setIsLike] = useState(props.isLike || false); // 是否喜欢
  const [isDislike, setIsDislike] = useState(props.isDislike || false); // 是否不喜欢

  // 点赞/点踩
  const handleClick = (type:string, isClick:boolean) => {
    let url = ''
    if (type === 'like') {
      url = isClick ? '/o/content/hitLike' : '/o/content/cancelHitLike'
    }
    if (type === 'disLike') {
      url = isClick ? '/o/content/hitDislike' : '/o/content/cancelHitDislike'
    }
    request.put(`${DOMAIN_API}${url}`, {
      contentId:id
    })
      .then(res => {
        console.log(res)
        if (type === 'like') {
          setIsLike(isClick)
          isDislike && setIsDislike(!isDislike)
        }
        if (type === 'disLike') {
          setIsDislike(isClick)
          isLike && setIsLike(!isLike)
        }
    })
    .catch(err => {
      console.log(err)
    })
  }
  return (
    <div className={`${styles['question-item']} ${showContent && styles['auto-height']}`}>
      <div className={styles['question-title']}>
        {title}
        <p className={`${styles['question-icon']} ${showContent && styles['flex-end']}`}>
          {!showContent && <i className={styles['purple-arrow']} onClick={() => {setShowContent(true)}}></i>}
          {showContent && <i className={styles['icon-close']} onClick={() => {setShowContent(false)}}></i>}
        </p>
      </div>
      {showContent && (
        <div className={styles['question-content-wrap']}>
          <p className={classNames(styles['question-content'], 'editor-wrap')} dangerouslySetInnerHTML={{__html:detail}}></p>
          {/* {cover && <img src={cover} alt="" />} */}
          {/* 是否有帮助 */}
          <Rate
            ctry={ctry}
            words={words}
            className={styles['question-rate']}
            isLike={isLike}
            isDislike={isDislike}
            handleClick={ (type:string, isClick:boolean)=>handleClick(type, isClick) } />
        </div>
      )}
      
    </div>
  )
}
export default QuestionItem
